import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser'

// Spec 090 — modèle 2-apps : l'identité CLIENTE (app SPA) est dissociée de l'AUDIENCE (app API).
//  - VITE_MSAL_CLIENT_ID     = appId de l'app SPA cliente (pragmelis-365-portail-client-{env})
//  - VITE_MSAL_API_CLIENT_ID = appId de l'app API (pragmelis-365-portail-{env}) = audience du scope
// Repli sur VITE_MSAL_CLIENT_ID si l'API n'est pas définie (compat. avant bascule 090 / app unique).
const apiClientId =
  (import.meta.env['VITE_MSAL_API_CLIENT_ID'] as string | undefined) ||
  (import.meta.env['VITE_MSAL_CLIENT_ID'] as string)

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env['VITE_MSAL_CLIENT_ID'] as string,
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (level === LogLevel.Error) console.error('[MSAL]', message)
        if (level === LogLevel.Warning) console.warn('[MSAL]', message)
      },
      logLevel: LogLevel.Warning,
    },
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)

export const loginRequest = {
  scopes: [`api://${apiClientId}/access_as_user`],
}
